export * from "./simple-product-grid.component";
